import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    body {
        color: ${({ theme }) => theme.color};
        background-color: ${({ theme }) => theme.bodyBackground};
    }
`;

export default GlobalStyle;